import { Component, OnInit, OnDestroy } from '@angular/core';

/**
 * Agenda: dünner Wrapper um den gemeinsamen Dispositions-Kalender (OrderDispositionComponent).
 * mode="agenda" zeigt alle team_base ohne Auftragskontext.
 * Keine doppelte Programmierung – Kalenderlogik liegt in order-disposition.
 */
@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css']
})
export class AgendaComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
